import Vue from 'vue';
import Vuex from 'vuex';
import common from './modules/common';
import form from './modules/form';
import bankcardList from './modules/common/bankcardList';
import fileUpload from './modules/common/fileUpload';
import modal from './modules/common/modal';
import index from './modules/index';
import products from './modules/products';
import productDetails from './modules/productDetails';
import step1 from './modules/applyLoan/step1';
import user from './modules/user';
import myInfo from './modules/personalCenter/myInfo';
import updatePassword from './modules/personalCenter/updatePassword';
import repaymentInfo from './modules/personalCenter/repaymentInfo';
import loanLists from './modules/personalCenter/loanLists';
import loanDetail from './modules/personalCenter/loanDetail';
import myLoan from './modules/personalCenter/myLoan';
import prepayment from './modules/personalCenter/prepayment';
import wholeRepay from './modules/personalCenter/wholeRepay';
import realNameAuth from './modules/personalCenter/realNameAuth';
import bank from './modules/bank';
import msg from './modules/msg';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: [common, msg, form, bankcardList, fileUpload, modal, index, products, productDetails, step1, user, myInfo, updatePassword, repaymentInfo, loanLists, loanDetail, myLoan, prepayment, wholeRepay, realNameAuth, bank],
  strict: process.env.NODE_ENV !== 'production'
});



// WEBPACK FOOTER //
// ./src/vuex/store.js